import axios from 'axios';
import { env } from '../utils/const';

const request = axios.create({
  baseURL: env.REACT_APP_AUTH_API,
  headers: {},
  // Sign-in responses set the httpOnly refresh cookie on the parent domain;
  // the browser only stores it when the request was made with credentials.
  withCredentials: true,
  validateStatus: function (status) {
    return true;
  },
});
export default request;
